import React from "react";
import MeasurerGraph from "./measurer-graph/measurer-graph";
import "./measurer-graph-dialog.scss";
import { ReactComponent as SvgDelta } from "../../../assets/delta.svg";

import { ReactComponent as SvgUpDown } from "../../../assets/swap-vertical.svg";
import { connect } from "react-redux";
import { changeMeasurerECG12GraphSettings, reportDataChanged } from "../../../redux/actions/report-actions";
import withLocalization from "../../../hoc/with-localization";

class MeasurerGraphDialog extends React.Component {
    leadNames = ["I", "II", "III", "AVR", "AVL", "AVF", "V1", "V2", "V3", "V4", "V5", "V6"];
    xScales = [10, 25, 50, 100];
    yScales = [5, 10, 20, 40];

    state = {
        leadsVals: this.leadNames.map(_lead => ({ name: _lead, v1: null, v2: null, delta: null, range: null })),
        area_width_ms_text: 0,
        area_width_ms: 0,
        startSelectPx: 0,
        endSelectPx: 0,
        areaForceUpdate: false,
        graphWidth_pts: undefined
    };

    componentDidMount() {
        this.setState({
            dragColors: ["#3d64ae", "#964b00"]
        });
    }

    onOk = () => {
        const {
            onSave,
            onClose,
            data: { medicalConclusion }
        } = this.props;
        onSave({ medicalConclusion: medicalConclusion + this.input.innerHTML });
        onClose();
    };

    onClose = () => this.props.onClose();

    onCancel = () => this.props.onClose();

    onDragMove = data => {
        this.setState(pre => {
            let startSelectPx = data.startSelectPx,
                endSelectPx = data.endSelectPx;
            return {
                leadsVals: pre.leadsVals.map((v, i) => {
                    v.delta = Math.abs(data.amplStart[i] - data.amplEnd[i]) / 1000;
                    v.delta = v.delta === undefined ? "" : v.delta.toFixed(2);
                    v.range = data.amplRange[i]?.max - data.amplRange[i]?.min;
                    if (v.range === Infinity || v.range === -Infinity) {
                        v.range = "";
                    } else v.range = (v.range / 1000).toFixed(2);
                    v.v1 = data.amplStart[i];
                    v.v1 = v.v1 === false ? "" : (v.v1 / 1000).toFixed(2);
                    v.v2 = data.amplEnd[i];
                    v.v2 = v.v2 === false ? "" : (v.v2 / 1000).toFixed(2);
                    return v;
                }),

                ms_px: data.ms_px,

                area_width_ms: Math.round((endSelectPx - startSelectPx) * data.ms_px),
                startSelectPx,
                endSelectPx,
                graphWidth_pts: data.graphWidth_pts
            };
        });
    };

    onAreaWidthChange = (areaWidthInMs, areaForceUpdate = false) => {
        if (areaWidthInMs <= 0) {
            this.setState({
                area_width_ms_text: ""
            });
            return;
        }

        this.setState({
            area_width_ms_text: areaWidthInMs,
            area_width_ms: areaWidthInMs,
            areaForceUpdate
        });
    };

    onCellClicked = (lead, val) => {
        if (!lead || val === undefined || val === null) {
            return;
        }
        const newComment = ` ${lead}: ${val} ${this.props.loc("units.mV")}`;
        this.input.innerHTML = this.input.innerHTML + newComment + "<br/>"; // Манипуляция напрямую минуя state, чтобы компонент не перерисовываля и не терял фокус
    };

    render() {
        const {
            loc,
            fd,
            changeSettings,
            data: { Q, S }
        } = this.props;
        const ms_pnt = val => (val === undefined || val === null || val === "" ? null : Math.round((val * fd) / 1000));
        const { onDragMove, onAreaWidthChange } = this;
        const { medicalConclusion, area_width_ms, leadsVals, dragColors, areaForceUpdate, area_width_ms_text } = this.state;

        return (
            <div className="resizer-container">
                <div className="popup-window popup-window_opened measurer-graph-popup-window">
                    <button type="button" className="popup-close-btn" onClick={() => this.onClose()}>
                        &times;
                    </button>
                    <form id="cmpxChooseForm" onSubmit={this.onOk}>
                        <h3 className="form-header">{loc("dialogs.measurer.title")}</h3>
                        <div className="form-content">
                            <div className="graph-wrapper">
                                <div className="aside">
                                    {medicalConclusion}

                                    <h4 className="vals-header">U, {loc("units.ms")}:</h4>
                                    <input
                                        type="number"
                                        min="1"
                                        value={area_width_ms_text}
                                        className="ctrl-input time-input"
                                        onChange={e => this.onAreaWidthChange(+e.target.value, true)}
                                    />

                                    <h4 className="vals-header">U, {loc("units.mV")}:</h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th style={{ color: dragColors?.[0] }}>
                                                    [ <div className="tooltip">{loc("dialogs.measurer.tooltip.cursorLeft")}</div>
                                                </th>
                                                <th style={{ color: dragColors?.[1] }}>
                                                    ] <div className="tooltip">{loc("dialogs.measurer.tooltip.cursorRight")}</div>
                                                </th>
                                                <th>
                                                    <SvgDelta />
                                                    <div className="tooltip">{loc("dialogs.measurer.tooltip.delta")}</div>
                                                </th>
                                                <th>
                                                    <SvgUpDown />
                                                    <div className="tooltip">{loc("dialogs.measurer.tooltip.range")}</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leadsVals.map((v, i) => (
                                                <tr key={v.name}>
                                                    <td>{v.name}:</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="button"
                                                            onClick={() => this.onCellClicked(v.name, v.v1)}
                                                            style={{ color: dragColors?.[0] }}>
                                                            {v.v1}
                                                        </button>{" "}
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="button"
                                                            onClick={() => this.onCellClicked(v.name, v.v2)}
                                                            style={{ color: dragColors?.[1] }}>
                                                            {v.v2}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="button"
                                                            onClick={() => this.onCellClicked(v.name, v.delta)}>
                                                            {v.delta}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="button"
                                                            onClick={() => this.onCellClicked(v.name, v.range)}>
                                                            {v.range}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="graphs">
                                    <MeasurerGraph
                                        Q={ms_pnt(Q)}
                                        S={ms_pnt(S)}
                                        loc={loc}
                                        areaWidth={area_width_ms}
                                        areaForceUpdate={areaForceUpdate}
                                        onAreaWidthChange={onAreaWidthChange}
                                        onDragMove={onDragMove}
                                        xScales={this.xScales}
                                        yScales={this.yScales}
                                        scale={this.props.scale}
                                        onChange={changeSettings}
                                    />
                                </div>
                            </div>
                            <div
                                className="comment-input ctrl-input scroll-styled"
                                contentEditable
                                dangerouslySetInnerHTML={{ __html: medicalConclusion }}
                                ref={el => (this.input = el)}
                                data-ph={loc("dialogs.measurer.placeholder")}
                            />
                        </div>

                        <div className="form-footer">
                            <div className="message-block">
                                <span className="message-block__text success_text"></span>
                            </div>
                            <input type="button" className="button button-ok" value="OK" onClick={this.onOk} />
                            <input type="button" className="button button-cancel" value={loc("buttons.cancel")} onClick={this.onClose} />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ reportApp: { reportData } }) => {
    const { measurerECG12Graph: scale } = reportData.settings.graphs;
    const { fd } = reportData.report.signal;
    return {
        scale,
        fd,
        report: reportData.report,
        medicalConclusion: reportData.report.medicalConclusion
    };
};
const mapDispatchToProps = {
    changeSettings: changeMeasurerECG12GraphSettings,
    reportDataChanged
};

export default connect(mapStateToProps, mapDispatchToProps)(withLocalization(MeasurerGraphDialog));
